var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrusted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_434)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.9854,
    r: 24,
    fill: "#1F94AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3514 22.941L23.7274 19.6521L22.1051 22.941L18.4731 23.4743L21.1016 26.0317L20.4794 29.6485L23.7274 27.9392L26.9754 29.6485L26.3531 26.0317L28.9789 23.469L25.3514 22.941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0776 24.8093L10.906 22.4351L9.73177 24.8102L7.11133 25.1906L9.00466 27.0386L8.56022 29.6484L10.9042 28.4164L13.2447 29.6484L12.8002 27.0386L14.6971 25.1906L12.0776 24.8093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9985 24.8093L36.827 22.4351L35.6536 24.8102L33.0332 25.1906L34.9265 27.0386L34.4821 29.6484L36.8261 28.4164L39.1665 29.6484L38.7221 27.0386L40.6181 25.1897L37.9985 24.8093Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.985352)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrusted);
export default __webpack_public_path__ + "static/media/trusted.00b936aa5e184d21726b871550bfd374.svg";
export { ForwardRef as ReactComponent };